import { baseApi } from '@store/baseApi';

import { DEFAULT_POLL_INTERVAL_MS } from '../constants';
import { fetchNotificationConfig } from '../services/fetchNotificationConfig';
import type { SystemNotificationsConfig } from '../types';

/**
 * System Notifications API - extends the base API with client-side notification polling
 * Uses queryFn to fetch from local JSON config instead of backend API
 */
export const systemNotificationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotificationConfig: builder.query<SystemNotificationsConfig | undefined, void>({
      queryFn: async () => {
        const config = await fetchNotificationConfig();
        return { data: config };
      },
    }),
  }),
});

export const { useGetNotificationConfigQuery } = systemNotificationsApi;
export const NOTIFICATION_POLL_INTERVAL = DEFAULT_POLL_INTERVAL_MS;
